import { ArrowUpDown } from "lucide-react";
import { SortData } from "../../DesignUploadStep.types";

export function SortIcon({ sortState, key }: { sortState: SortData<any> | null; key: string }) {
  if (sortState?.key !== key) {
    return <ArrowUpDown className="h-3.5 w-3.5 opacity-50" />;
  }

  return <span className="text-xs font-medium">{sortState?.direction === "asc" ? "↑" : "↓"}</span>;
}
